import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { RouterModule } from '@angular/router';
import { ShNotificationComponent } from '../elements/components/notification/notification.component';
import { ShPageHeaderComponent } from '../elements/components/page-header/page-header.component';
import { ShDisplaySettingsBarComponent } from '../overviews/generic-overview/components/display-settings-bar/display-settings-bar.component';
import { ShPaginationComponent } from '../overviews/generic-overview/components/pagination/pagination.component';

import { ShReportDetailContainerComponent } from './containers/report-detail-container/report-detail-container.component';
import { ShReportsOverviewContainerComponent } from './containers/reports-overview-container/reports-overview-container.component';
import { ShReportsSandboxService } from './sandbox/reports-sandbox.service';

@NgModule({
    imports: [
    CommonModule,
    TranslateModule,
    ShPageHeaderComponent,
    ShNotificationComponent,
    ShPaginationComponent,
    ShDisplaySettingsBarComponent,
    RouterModule,
    ShReportsOverviewContainerComponent, ShReportDetailContainerComponent
],
    providers: [ShReportsSandboxService],
    exports: [ShReportsOverviewContainerComponent, ShReportDetailContainerComponent]
})
export class ShReportsModule {}
